import React from 'react';
import { Box, Button, Grid } from '@mui/material';
import { CptCodeChip } from './CptCodeChip';
import { ConsentHelpIcon } from './ConsentHelpIcon';
export const CgmConsentSection = (props) => {
    const { active, activeChanged } = props;
    return (React.createElement(Box, { sx: { marginBottom: 2 } },
        React.createElement(Box, { sx: {
                backgroundColor: '#F5F5F5',
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: 'default',
                borderRadius: '8px',
                transition: 'border-radius 0.2s ease',
            } },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 8, sx: { display: 'block', alignItems: 'left', gap: 1 } },
                    React.createElement("div", { className: 'flex' },
                        React.createElement(Box, { sx: {
                                fontFamily: 'Barlow',
                                fontSize: '16px',
                                fontWeight: 500,
                                color: '#1F2937',
                                display: 'flex'
                            } },
                            "Data Sharing ",
                            React.createElement(ConsentHelpIcon, { program: 'CGM' }))),
                    React.createElement(CptCodeChip, { code: '95251' })),
                React.createElement(Grid, { item: true, xs: 4, style: { marginTop: 'auto', marginBottom: 'auto' } },
                    React.createElement(Button, { style: {
                            backgroundColor: active ? '#43A047' : '#E0E0E0',
                            color: active ? 'white' : 'black',
                            float: 'right',
                            borderRadius: '25px',
                            width: '100px',
                            height: '30px'
                        }, onClick: () => activeChanged(!active) }, active ? 'Active' : 'Activate'))))));
};
